<template lang="pug">
section.v-main-page-section.main-page-section(v-if="section" )
	.container
		v-main-section-header.main-page-section__header(
			v-if="section.header"
			:data="section.header"
			@navigation="setNavigation")
		v-section-bottom-slider(
			v-if="section.slider && section.slider.type === 'bottom'"
			:slider="section.slider")
		v-section-slider(
			v-else-if="section.slider"
			:slider="section.slider"
			:navigation="navigation")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [sourceMixin],

	data() {
		return {
			section: null,
			navigation: false
		};
	},

	methods: {
		dataSet(data) {
			this.section = data;
		},

		setNavigation(navigation) {
			this.navigation = navigation;
		}
	},
};
</script>